import {  createSlice } from "@reduxjs/toolkit";


export const RoleSlice = createSlice({
  name: 'role',
  initialState: {
    commandCenterRole: false,
    roles: []
  },
  reducers: {
    setRole: (state, action) => {
      state.commandCenterRole = action.payload.isCommandCenterRole;
      state.roles = action.payload.userRoles;
    },
  }
});

export const setCommandCenterRole = (state) => state.role.commandCenterRole;
export const getUserRoles = (state) => state.role.roles;
export const isAdmin = (state) => state.role.roles.includes('admin');


export const {setRole} = RoleSlice.actions;
export default RoleSlice.reducer;